const TOURNAMENT = {
  STAKE_OPTIONS: "stake-options",
  TOURNAMENT_PARTICIPANTS: "tournament-participants",
  DUEL_ENTRY: "duel-entry",
  DUEL_OPPONENT: "duel-opponent",
  TOURNAMENT_DETAILS: "tournament-details",
  MULTIPLAYER_TOURNAMENTS: "multiplayer-tournaments",
  ACTIVE_TOURNAMENTS: "active-tournaments",
  RECENT_GAMERS_SUMMARY: "recent-gamers-summary",
  CANCEL_ENTRY: "cancel-entry",
  PLAY_PRACTICE_GAME: "play-practice-game",
  PLAY_SOLO_GAME: "play-solo-game",
  ENTRY_DETAILS: "entry-details",
  ENTRY_LIST: "entry-list",
  FORFEIT_ENTRY: "forfeit-entry",
  GAMEPLAY_RESULTS: "gameplay-results",
} as const;

const GAME = {
  GAME_DETAILS: "game-details",
  ALL_GAMES: "all-games",
  MY_TOP_GAMES: "my-top-games",
  POPULAR_GAMES: "popular-games",
  MY_FAVORITE_GAMES: "my-favorite-games",
  GAME_CATEGORIES: "game-categories",
  MY_DEFAULT_GAME: "my-default-game",
  LOG_GAMEPLAY_EVENT: "log-gameplay-event",
  FILTERED_GAMES: "filtered-games",
} as const;

const WALLET = {
  WALLET_LIST: "wallet-list",
  GEM_RESPONSE: "gem-response",
  PURCHASE_PLANS: "purchase-plans",
  EXCHANGE_RATES: "exchange-rates",
  PAYMENT_PROVIDERS: "payment-providers",
};

const CHALLENGE = {
  CHALLENGE_INVITATIONS: "challenge-invitations",
  PENDING: "pending-challenges",
};

const CONFIGURATIONS = {
  SOCIAL_LINKS_BY_COUNTRY: "social-links-by-country",
};

const USER = {
  PROFILE: "user-profile",
  VERIFICATION_STATUS: "verification-status",
};

const STREAK = {
  STATUS: "streak-status",
} as const;

const ACTIVITY = {
  BASE: "activity",
  RESULT_ACTIVITIES: "result-activities",
  UNVIEWED_COUNT: "unviewed-result-count",
} as const;

const SUBSCRIPTION = {
  IS_SUBSCRIBED: "is-subscribed",
  OFFERINGS: "rc-offerings",
} as const;

const ATTRIBUTION = {
  SAVE: "save-attribution",
} as const;

export const QUERY_KEYS = {
  TOURNAMENT,
  GAME,
  WALLET,
  CHALLENGE,
  CONFIGURATIONS,
  USER,
  STREAK,
  ACTIVITY,
  SUBSCRIPTION,
  ATTRIBUTION,
} as const;
